import { createFileRoute, redirect } from '@tanstack/react-router';
import { inboxPreviewUsageSearch } from './-billing-legacy-search';

// The Inbox preview usage card on the Usage tab replaces this tab. Old bookmarks still use this URL.
export const Route = createFileRoute('/_authenticated/settings/billing/inbox-preview-usage')({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/settings/billing/usage',
      search: inboxPreviewUsageSearch(location.search),
      replace: true,
    });
  },
});
